import React from 'react'

const TooltipAnchor = (props) => (
  <svg width="24" height="11" viewBox="0 0 24 11" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M24 0L14.8284 9.17157C13.2663 10.7337 10.7337 10.7337 9.17157 9.17157L0 0H24Z" />
  </svg>
)

export default TooltipAnchor
